import React from 'react';
import Layout from '../Components/Layout';
import { Link } from 'react-router-dom';
import companys_benefit from '../Assets/images/companys-benefit.png'
import Karmaempire from '../Assets/images/karma-empire.png'
import poppklogo from '../Assets/images/poppklogo.png'
import cartoon from '../Assets/images/cartoon.png'
import gst_cer from '../Assets/images/gst_cert.png'


import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';

function AboutUs(props) {
    return (
        <Layout>
            <section className=' common-space-both square-box'>
                <div className='container'>
                    <div className='grid grid-cols-4 mt-4 gap-5 mobile:grid-cols-1'>
                        <div className='common-title col-span-3 flex flex-col'>
                            <img src={Karmaempire} className='img-fluid w-1/4' />
                            <p>Poppk.in is an advertisement and marketing company. The company is registered as Kaarma empire. Poppk.in is a marketing product and it is headquartered in Surat. It is an advertisement company. Poppk.in works to bring product and costumers together on one platform and is an interesting platform to earn income together.</p>
                            <div>
                                <button className='btn-common inline-flex gap-2 items-center mt-4'>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M12 3V16M12 16L16 11.625M12 16L8 11.625" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    Download Brochure
                                </button>
                            </div>

                            <span className='text-[#F0643B] text-[100px] opacity-5 font-black mobile:text-[50px] leading-[75px] block pt-10 mt-auto'>POPPK.in</span>
                        </div>
                        <div>
                            <img src={cartoon} className='img-fluid' />
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className='bg-[#F4F4F4] common-space-both'>
                <div className='container'>
                    <div className='grid grid-cols-4 place-items-center gap-4'>

                        <div className='common-title col-span-3 mobile:col-span-full'>
                            <h2>Legal Documents</h2>
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                            <ul className='certificate-btn mt-4 flex gap-3'>
                                <li>
                                    <label>
                                        <input type='radio' name='certi' />
                                        <span>GSTIN Certificate</span>
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <input type='radio' name='certi' />
                                        <span>GST</span>
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <input type='radio' name='certi' />
                                        <span>SMC Certificate</span>
                                    </label>
                                </li>
                            </ul>
                        </div>
                        <div className='bg-white rounded-xl p-3 mobile:col-span-full'>
                            <p className='text-black font-semibold mb-4'>GSTIN Certificate</p>
                            <img src={gst_cer} />
                        </div>
                    </div>

                </div>
            </section> */}
            <section className='container common-space-both'>
                <div className='grid grid-cols-2 mt-4 gap-5 tablet:grid-cols-1 tablet:place-items-center'>
                    <div className='common-title'>
                        <h2>Company’s Benefit</h2>
                        <p>When we take a package of 1000, we get the benefits of advertisement. For only 1000 rupees, the company gives us the opportunity to market our product, shop or company in 30 days.</p>
                        <p>The company is also typed with tours and travels companies, which benefits can also be obtained, like when we take a tour package from tours and travels typed with the company, then they also make a commission of one thousand from them, we will get the benefits of the service for life.</p>
                        <p>You will also get benefit from other projects of the company, like if the company sells its products, then the income can be received in the form of discounts.</p>
                        <Link to={''} className='btn-common'>Contact us</Link>
                    </div>
                    <div>
                        <img src={companys_benefit} className='img-fluid' />
                    </div>
                </div>
            </section>
            <section className='container common-space'>
                <div className='common-title'>
                    <h2>Level Benefits</h2>
                </div>
                <div className='cust-table mt-5'>
                    <table>
                        <thead>
                            <tr>
                                <th>TIER</th>
                                <th>ADVS</th>
                                <th>COMMISSION</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Star Seller</td>
                                <td>5</td>
                                <td>20%</td>
                            </tr>
                            <tr>
                                <td>Silver Sales Executive</td>
                                <td>25</td>
                                <td>10%</td>
                            </tr>
                            <tr>
                                <td>Gold Sales Manager</td>
                                <td>125</td>
                                <td>5%</td>
                            </tr>
                            <tr>
                                <td>Rubby Area Manager</td>
                                <td>625</td>
                                <td>5%</td>
                            </tr>
                            <tr>
                                <td>Diamond District Manager</td>
                                <td>3125</td>
                                <td>5%</td>
                            </tr>
                            <tr>
                                <td>Blue State Manager</td>
                                <td>15625</td>
                                <td>2%</td>
                            </tr>
                            <tr>
                                <td>President Royal</td>
                                <td>78125</td>
                                <td>2%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </section>
            <section className='container common-space-both'>
                <div className=" w-full">
                    <div className="mx-auto w-full  divide-y divide-white/5 rounded-xl bg-white/5">
                        <Disclosure as="div" className="" defaultOpen={true}>
                            {({ open }) => (
                                <>
                                    <DisclosureButton className="group flex w-full items-center justify-between text-start border-b pb-2">
                                        <span className="text-black text-xl font-bold mobile:text-lg ">
                                            Star Seller
                                            <p className='text-black text-base font-semibold mobile:text-base'>
                                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                            </p>
                                        </span>
                                        <svg className={open ? 'rotate-0' : 'rotate-180'} width="20" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.75 9.25L11 1.75L2.25 9.25" stroke="black" strokeWidth="3" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </DisclosureButton>
                                    <DisclosurePanel className="pt-5">
                                        <div className='pl-10 line-gradi'>
                                            <p className='text-black'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                            <div className='gradiant-box mt-5'>
                                                <h3 className='text-black font-bold text-xl'>Benefits </h3>
                                                <ul className='list-disc pl-5 text-black [&>li]:pb-2 pt-2 font-semibold'>
                                                    <li>2000 gets immediately</li>
                                                    <li>+4000 will get after 30 days</li>
                                                    <li>Total income will be 6000.</li>


                                                </ul>

                                            </div>
                                        </div>
                                    </DisclosurePanel>
                                </>
                            )}

                        </Disclosure>
                        <Disclosure as="div" className="pt-4" defaultOpen={false}>
                            {({ open }) => (
                                <>
                                    <DisclosureButton className="group flex w-full items-center justify-between text-start border-b pb-2">
                                        <span className="text-black text-xl font-bold mobile:text-lg ">
                                            Silver Seller
                                            <p className='text-black text-base font-semibold mobile:text-base'>
                                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                            </p>
                                        </span>
                                        <svg className={open ? 'rotate-0' : 'rotate-180'} width="20" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.75 9.25L11 1.75L2.25 9.25" stroke="black" strokeWidth="3" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </DisclosureButton>
                                    <DisclosurePanel className="pt-5">
                                        <div className='pl-10 line-gradi'>
                                            <p className='text-black'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                            <div className='gradiant-box mt-5'>
                                                <h3 className='text-black font-bold text-xl'>Benefits </h3>
                                                <ul className='list-disc pl-5 text-black [&>li]:pb-2 pt-2 font-semibold'>
                                                    <li>2000 gets immediately</li>
                                                    <li>+4000 will get after 30 days</li>
                                                    <li>Total income will be 6000.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </DisclosurePanel>
                                </>
                            )}

                        </Disclosure>
                        <Disclosure as="div" className="pt-4" defaultOpen={false}>
                            {({ open }) => (
                                <>
                                    <DisclosureButton className="group flex w-full items-center justify-between text-start border-b pb-2">
                                        <span className="text-black text-xl font-bold mobile:text-lg ">
                                            Golden Sales Manager
                                            <p className='text-black text-base font-semibold mobile:text-base'>
                                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                            </p>
                                        </span>
                                        <svg className={open ? 'rotate-0' : 'rotate-180'} width="20" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M19.75 9.25L11 1.75L2.25 9.25" stroke="black" strokeWidth="3" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </DisclosureButton>
                                    <DisclosurePanel className="pt-5">
                                        <div className='pl-10 line-gradi'>
                                            <p className='text-black'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                            <div className='gradiant-box mt-5'>
                                                <h3 className='text-black font-bold text-xl'>Benefits </h3>
                                                <ul className='list-disc pl-5 text-black [&>li]:pb-2 pt-2 font-semibold'>
                                                    <li>2000 gets immediately</li>
                                                    <li>+4000 will get after 30 days</li>
                                                    <li>Total income will be 6000.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </DisclosurePanel>
                                </>
                            )}

                        </Disclosure>

                    </div>
                </div>
            </section>
            <section className='container  common-space-both'>
                <div className='bg-gradient-to-r from-[#F0643B] to-[#F7AC16] rounded-xl common-space-both relative overflow-hidden'>

                    <div className='common-title text-center '>
                        <h1 className='center-line !text-white after:hidden'>Lorem Ipsum is simply dummy text of the printing <br />
                            <span> and typesetting industry</span> </h1>
                        <p className='!text-white mt-4'>Lorem Ipsum is simply dummy text of the printing.</p>
                        <div className='flex gap-3 items-center justify-center'>
                            <Link className='btn-common !bg-[#FFFFFF33] !text-white !font-medium mt-6' to="/know-more">Know More</Link>
                            <Link className='btn-common !bg-[#FFFFFF33] !text-white !font-medium mt-6'>Contact us</Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className='container common-space-both'>
                <div className='grid grid-cols-3 mt-4 gap-5 tablet:grid-cols-1 tablet:place-items-center'>
                    <div className='common-title col-span-2'>
                        <h2>Founder Kaarma Empire</h2>
                        <p>|| कर्मण्येवाधिकारस्ते मा फलेषु कदाचन ||</p>
                        <p>This company is doing digital marketing cosmetic chemicals and artificial intelligence solution provider and many other fields.</p>
                        <p> The company head office is in Surat and company is registered with government from Surat. The main objective of the company is to provide customers to the company and the purpose of delivering the company’s product to the Digital customer is to generate income from it, so that the customers can easily see the new product in the world and if it the income is generated, the ability to make the product will increase.</p>
                        <h5 className='font-bold text-lg text-black my-4'>Benefits:</h5>
                        <ul className='list-disc pl-5 text-black flex flex-col gap-3'>
                            <li>You become a sharer of the company's net profits which can be huge.</li>
                            <li>You can become a shareholder of the dividend declared by the company, get another product of the company as a discount.</li>
                            <li>Discounts can be obtained in the tour package of the company, many other products of the company are coming and if there are, you can also get the benefit of it.</li>
                        </ul>


                        <button className='btn-common flex gap-2 items-center mt-4'>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 15C3 17.8284 3 19.2426 3.87868 20.1213C4.75736 21 6.17157 21 9 21H15C17.8284 21 19.2426 21 20.1213 20.1213C21 19.2426 21 17.8284 21 15" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 3V16M12 16L16 11.625M12 16L8 11.625" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Download Brochure
                        </button>
                    </div>
                    <div className='flex flex-col justify-between'>
                        <img src={Karmaempire} className='img-fluid' />
                        <span className='text-[#F0643B] text-[100px] opacity-5 font-black mobile:text-[50px] leading-[75px]	'>Kaarma <br />
                            Empire</span>
                    </div>
                </div>
            </section>
            <section className='container  common-space-both'>
                <div className='bg-[#F0643B] rounded-xl common-space-both relative overflow-hidden'>
                    <div>
                        <img src={poppklogo} className='absolute bottom-0' />
                        <img src={poppklogo} className='absolute -right-10 top-0 -rotate-45' />

                    </div>

                    <div className='common-title text-center '>
                        <h2 className='center-line !text-white after:hidden'>Passive Income</h2>
                        <p className='!text-white px-4'>Poppk.in is the first company to gave passive income. Poppk.in gives passive income to every advertiser who have star such as silver, gold, diamond, bluediamond, ruby and president.</p>
                        <Link className='btn-common !bg-white mt-6'>Contact us</Link>
                    </div>
                </div>
            </section>

        </Layout>
    );
}

export default AboutUs;